export class StoreDetail {
  StoreId = '';
  StoreName = '';
  StoreUrl = '';
  UserId = '';
  Description = '';
  apiKey = '';
  About = '';
  IsActive = false;
  CanEndUserCustomize = false;
  StoreCategoryMappings = {};
  StoreContact = new StoreContact();
  StoreSocialMedia = new StoreSocialMedia();
  StoreSettings = new StoreSettings();
}
export class StoreDetailKey {
  StoreId = '';
  apikey = '';
}

export class StoreContact {
  ContactPersonName = '';
  ContactNumber = '';
  ContactEmail = '';
  AddressLine1 = '';
  AddressLine2 = '';
  PinCode = '';
  StateId = '';
  CountryId = '';
  City = '';
  Landmark = '';
}

export class StoreSocialMedia {
  FacebookUrl = '';
  TwitterUrl = '';
  InstagramUrl = '';
  YouTubeUrl = '';
}

export class StoreSettings {
  HeaderColorCode = '';
  HeaderFontColorCode = '';
  FooterColorCode = '';
  FooterFontColorCode = '';
  FooterLinksColorCode = '';
  StoreImageBanner = '';
  StoreLogo = '';
  BannerText1 = '';
  BannerText2 = '';
  BannerText1Color = '';
  BannerText2Color = '';
  BannerText1Size = '';
  BannerText2Size = '';
}


export interface StrAdmnCommissionFilterModel {
  Skip: number;
  Take: number;
  searchBy: string;
  UserId: string;
  status: string;
}
export interface StrAdmnPublishedProductFilterModel {
  Skip: number;
  Take: number;
  UserId: string;
  StoreId: string;
}
export interface StrAdmnPublishedProductUpdateModel {
  UserId: string;
  StoreId: string;
  CustomizedProductId: string;
  RetailPrice: string;
}
export interface StrAdmnPublishedProductDeleteModel {
  UserId: string;
  StoreId: string;
  CustomizedProductId: string;
 
}
export interface StrAdmnWareHousePublishedProductDeleteModel {
  UserId: string;
  StoreId: string;
  WareHouseProductId: number
}
